<template>

  <b-form-group  :label="fullLabel" label-for="id-input" 
                :label-class="labelClass" label-size="sm">
    <b-form-input 
        v-model="localValue"
        id="id-input" 
        :type="type"
        :name="name" 
        :placeholder="placeholder"
        :disabled="disabled" 
        :required="required"
        size="sm">
    </b-form-input>
  </b-form-group>
  
</template>

<script>

// https://sergiocarracedo.es/2019/12/05/tu-propio-v-model-en-un-componente-vue/
export default {
  name: 'Input',
  props: {
    value: {
      required: true
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      required: true,
    },
    labelClass: {
      type: String,
      default: ""
    },
    disabled:{
      type: Boolean, 
      default: false
    }, 
    placeholder:{
      type: String,
      default: "..."
    }, 
    required: {
      type: Boolean, 
      default: false
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  computed: {
    name() {
      return this.label.toLowerCase();
    },
    fullLabel() {
      return this.required ? this.label + " * " : this.label 
    },
  },
  watch: {
     localValue (newValue) {
       this.$emit('input', newValue)
     },
     value (newValue) {
       this.localValue = newValue;
     }
  }
}

</script>

<style scoped>
</style>